export const handleChangeSelectWarehouse = (
    userId: number,
    idWarehouse: string,
) => {
    localStorage.setItem(`user${userId}`, idWarehouse);
};

export const getWarehouseId = (userId: number) => {
    return localStorage.getItem(`user${userId})`);
};

export const setLocalWarehouseId = (userId: number, idWarehouse: number) => {
    const userKey = `user${userId}`;
    try {
        window.localStorage.setItem(userKey, String(idWarehouse));
    } catch (error) {
        throw error;
    }
};

export const getLocalWarehouseId = (userId: number) => {
    const userKey = `user${userId}`;
    try {
        const warehouseId = window.localStorage.getItem(userKey);
        if (warehouseId) {
            return Number(warehouseId);
        }
        return null;
    } catch (error) {
        throw error;
    }
};

export const setLocalColor = (userId: number, color: string) => {
    const userKey = `user${userId}__color`;
    try {
        window.localStorage.setItem(userKey, color);
    } catch (error) {
        throw error;
    }
};

export const getLocalColor = (userId: number) => {
    const userKey = `user${userId}__color`;
    try {
        const color = window.localStorage.getItem(userKey);
        if (color) {
            return color;
        }
        return null;
    } catch (error) {
        throw error;
    }
};
